<div
  class="fixed inset-x-0 bottom-0 left-[320px] z-50 flex min-h-[92px] flex-row gap-8 border bg-background-paper px-8 py-4 max-2xl:gap-2"
>
  <div class="flex max-w-[658px] flex-1 flex-col content-center gap-1">
    <div class="flex items-center">
      <mat-icon
        class="material-icons-outlined !inline-flex h-8 place-content-center text-base text-blue"
      >
        info
      </mat-icon>
      <span class="text-base text-primary">
        {{ getNumberofChanges() }}
      </span>
    </div>
    <p class="pl-6 text-xs">
      {{
        'portal.courseSettings.topicAreaSettings.saveChangesBanner.information'
          | transloco
      }}
    </p>
  </div>
  <div
    class="flex max-w-[658px] flex-row items-center gap-3 max-lg:flex-col max-lg:items-end"
  >
    <app-secondary-button
      leadingIcon="close"
      [text]="
        'portal.courseSettings.topicAreaSettings.saveChangesBanner.discard'
          | transloco
      "
      (buttonClicked)="onCancelButtonClicked()"
    >
    </app-secondary-button>
    <app-primary-button
      icon="save"
      [text]="
        'portal.courseSettings.topicAreaSettings.saveChangesBanner.save'
          | transloco
      "
      (buttonClicked)="saveVariableChanges()"
    >
    </app-primary-button>
  </div>
</div>
